<template>
  <div class="apply">

    <div class="apply-top">
      <van-nav-bar title="管理员信息">
        <template #left>
          <van-icon name="arrow-left" size="24" @click="goBack"/>
        </template>
        <template #right>
          <van-icon name="replay" size="24" @click="reset" v-if="isShowReset === true"/>
        </template>
      </van-nav-bar>
    </div>

    <div class="apply-body">
      <van-skeleton :row="3" :loading="loading" :style="{ paddingTop: '16px' }">
        <van-form @submit="handleSubmit"  ref="jobUploadForm" scroll-to-error>
          <van-cell-group inset class="submit-form">

            <van-field v-model.trim="peopleInfo['username']" name="username" label="姓名" placeholder="请输入"
                       clearable
                       :rules="[{ required: true, message: '姓名不能为空' }]" required />

            <van-field v-model.trim="peopleInfo['phone']" name="username" label="手机号" placeholder="请输入"
                       type="tel" clearable
                       :rules="[{ required: true, message: '手机号不能为空' }]" required />

            <van-field v-model="peopleInfo['companyName']" name="benefit" label="公司" placeholder="请选择"
                       type="textarea" autosize readonly is-link @click="isShowCompany = true"
                       :rules="[{ required: true, message: '公司不能为空' }]" required />
            <van-popup v-model:show="isShowCompany" round position="bottom">
              <van-nav-bar title="选择公司"
                           right-text="确认" @click-right="isShowCompany = false">
                <template #left>
                  <van-checkbox v-model="isCheckAll" :indeterminate="isIndeterminate" @change="checkAllChange">
                    全选
                  </van-checkbox>
                </template>
              </van-nav-bar>
              <van-checkbox-group v-model="checkedResult" @change="checkedResultChange">
                <van-cell-group inset>
                  <van-cell v-for="item in companyOption" :key="item['value']" :title="item['text']">
                    <template #right-icon>
                      <van-checkbox :name="item['text']"/>
                    </template>
                  </van-cell>
                </van-cell-group>
              </van-checkbox-group>
            </van-popup>

          </van-cell-group>

          <div class="button">
            <van-button class="submit-button" type="primary" round block native-type="submit">保存</van-button>
          </div>

        </van-form>
      </van-skeleton>
    </div>

  </div>
</template>

<script>
import {getAllCompanyOption, setManager} from "@/api";
import {selectDictValue} from "@/api/common";
import {showConfirmDialog, showDialog, showNotify} from "vant";

export default {
  name: "ManagerForm",
  data() {
    return {
      loading: true,
      peopleInfo: {},
      isShowReset: false,

      isShowCompany: false,
      companyOption: [],

      isCheckAll: false,
      isIndeterminate: false,
      checkedResult: [],

      form: undefined,
    }
  },
  mounted() {
    this.loading = true;
    this.peopleInfo = JSON.parse(window.sessionStorage.getItem('peopleInfo'));
    if (this.peopleInfo['username'] === null || this.peopleInfo['username'] === undefined || this.peopleInfo['username'] === 'undefined') {
      this.checkedResult = [];
      this.isShowReset = false;
    } else {
      this.checkedResult = this.peopleInfo['companyName'].split('、');
      this.isShowReset = true;
    }
    getAllCompanyOption().then((res) => {
      if (res.code === 200) {
        this.companyOption = res.data;
        this.loading = false;
      }
    });
  },
  methods: {
    goBack() {
      window.sessionStorage.removeItem('peopleInfo');
      window.history.back();
    },
    reset() {
      this.peopleInfo = JSON.parse(window.sessionStorage.getItem('peopleInfo'));
      this.checkedResult = this.peopleInfo['companyName'].split('、');
    },
    checkAllChange(isAll) {
      this.checkedResult = [];
      this.peopleInfo['companyName'] = '';
      this.peopleInfo['companyId'] = '';
      if (isAll === true) {
        for (let item of this.companyOption) {
          this.checkedResult.push(item['text']);
          this.peopleInfo['companyName'] += item['text'] + '、';
          this.peopleInfo['companyId'] += item['value'] + ',';
        }
        this.peopleInfo['companyName'] = this.peopleInfo['companyName'].substring(0, this.peopleInfo['companyName'].length - 1);
        this.peopleInfo['companyId'] = this.peopleInfo['companyId'].substring(0, this.peopleInfo['companyId'].length - 1);
      }
    },
    checkedResultChange(option) {
      this.checkedResult = option;
      this.isIndeterminate = option.length > 0 && option.length < this.companyOption.length;

      let optionSorted = {};
      for (let item of option) {
        optionSorted[selectDictValue(this.companyOption, item)] = item;
      }
      this.peopleInfo['companyName'] = '';
      this.peopleInfo['companyId'] = '';
      for (let key in optionSorted) {
        this.peopleInfo['companyName'] += optionSorted[key] + '、';
        this.peopleInfo['companyId'] += key + ',';
      }
      this.peopleInfo['companyName'] = this.peopleInfo['companyName'].substring(0, this.peopleInfo['companyName'].length - 1);
      this.peopleInfo['companyId'] = this.peopleInfo['companyId'].substring(0, this.peopleInfo['companyId'].length - 1);
    },
    handleSubmit() {
      let keys = Object.keys(this.peopleInfo);
      let flag = 0;

      let peopleInfo = JSON.parse(window.sessionStorage.getItem('peopleInfo'));
      for (let i = 0; i < keys.length; i++) {
        let key = keys[i];
        if (key === 'number') {
          if (Number(this.peopleInfo[key]) === Number(peopleInfo[key])) {
            flag++;
          }
        } else {
          if (this.peopleInfo[key] === peopleInfo[key]) {
            flag++;
          }
        }
      }

      if (flag === keys.length) {
        showDialog({
          message: '未进行任何修改。',
        }).then(() => {
        });
      } else {
        this.form = new FormData();
        for (let i = 0; i < keys.length; i++) {
          let key = keys[i];
          if (key === 'createtime' || key === 'updatetime') {
            continue;
          }
          this.form.append(key, this.peopleInfo[key]);
        }

        showConfirmDialog({
          message: '是否确认保存？',
        }).then(() => {
          setManager(this.form).then((res) => {
            if (res.code === 200) {
              showNotify({ type: 'success', message: '管理员设置成功！', position: 'bottom' });
              this.goBack();
            } else {
              showNotify({ type: 'danger', message: '服务器繁忙，请稍后再试。', position: 'bottom' });
            }
          });
        }).catch(() => {
          // on cancel
        });
      }

    },
  }
}
</script>

<style scoped>
.apply {
  width:100%;
  height: 100vh;
  display: flex;
  flex-direction: column;
}

.apply-top {
  background-color: rgb(248,248,248);
  padding-bottom: 10px;
}

.apply-body {
  flex: 1;
  overflow-y: scroll;
  padding-bottom: 20px;
}

.submit-form {
  margin: 0;
}

.button {
  padding: 0 16px 20px;
}

.submit-button {
  font-size: 18px;
  margin-top: 20px;
}
</style>